/* eslint-disable react/jsx-pascal-case */
import { Button, Col, ConfigProvider, Form, Row, Modal } from "antd";
import dayjs from 'dayjs';
import React, { useContext, useEffect, useRef, lazy, Suspense, useState } from "react";
import CompetencyForm from "./competency_form";
import { Button as CustomButton, Modal as CustomModal } from "../../../../../templates/my-app/src/components/ui/ot"
const { ConfigContext } = ConfigProvider


const CompetencyModal = (
    {
        axiosMode = "post",
        propsForm,
        propsOpen = null,
        propsLoading = null,
        propsSetOpen = () => {

        },
        onFinish = () => {

        },
        changeAxiosMode = () => {}, 
        is_editing = false,
        set_is_editing = () => {},
        modal_form_data = [],
        open = false,
        set_competent_modal_open = () => {},
        props_delete_open,
        default_props_delete_open = false,
        onDeleteFinish = () => {}
    }
) => {

    const axiosModelanguage = {
        post: "新增",
        patch: "修改"
    }
    const [form] = Form.useForm();
    // const [modalAxiosMode, setModalAxiosMode] = useState(axiosMode);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(props_delete_open ? props_delete_open : default_props_delete_open);
    const [loading, setLoading] = useState(false)
    const [formReloadCount, setFormReloadCount] = useState(0)
    const showModal = () => {
        changeAxiosMode("post")
        set_competent_modal_open(true)
        setFormReloadCount(pre => pre + 1)
        if (propsOpen === null) {
            setIsModalOpen(true);
        }
        else {
            propsSetOpen(true)
        }
    };
    const showDeleteModal = () => {
        setIsDeleteModalOpen(true)
    };
    const closeModal = () => {
        set_is_editing(false)
        if (propsOpen === null) {
            setIsModalOpen(false);
        }
        else {
            propsSetOpen(false)
        }
    }
    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false)
    }

    const handleOk = () => {
        setLoading(true)
        if (propsForm) {
            propsForm.submit()
        }
        else {
            form.submit()
        }
    };
    const handleDeleteModalOk = () => {
        onDeleteFinish()
        closeDeleteModal()
    };

    const handleCancel = () => {
        closeModal()
    };
    const onFormFinish = (values) => {
        if(is_editing) {
            changeAxiosMode("patch")
        }
        onFinish(values)
    }
    useEffect(() => {
        setFormReloadCount(pre => pre + 1)
    }, [propsOpen])
    useEffect(() => {
        console.log(open)
        if(!open) closeModal()
    }, [open])

    useEffect(() => {
        setIsDeleteModalOpen(props_delete_open)
    }, [props_delete_open])


    return (
        <>
            <div
                className={
                    "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2"
                }
            >
            {
                propsOpen === null &&
                <CustomButton 
                    size={"small"}
                    type="primary" 
                    onClick={showModal}
                >
                    {axiosModelanguage[axiosMode] === "patch" ? "修改" : "新增"}資料
                </CustomButton>
            }
            <CustomButton onClick={showDeleteModal}
                size={"small"}
                style={{
                    backgroundColor: '#FF0000',
                    borderColor: '#FF0000',
                    color: 'white',
                }}
            >
                刪除資料
            </CustomButton>
            </div>

            <CustomModal 
                open={isDeleteModalOpen}
                title={"刪除確認"}
                children={"請確認是否要刪除所選資訊"}
                onCancel={closeDeleteModal}
                onOk={handleDeleteModalOk}
                okText={"確認"}
                cancelText="取消"
                contentStyle={{ padding: 20 }}
                width={"100%"}
            ></CustomModal>

            <Modal
                style={{ top: 10 }}
                title={`${axiosModelanguage[axiosMode] === "patch" ? "修改" : "新增"}資料`}
                open={propsOpen === null ? (is_editing) ? is_editing : isModalOpen : propsOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
            >
                <Row
                    style={{
                        maxHeight: "80vh",
                        overflowX: "scroll",
                        overflowY: "scroll",
                    }}
                >
                    <Col span={24}>
                        <CompetencyForm
                            formReloadCount={formReloadCount}
                            open={propsOpen === null ? (is_editing) ? is_editing : isModalOpen : propsOpen}
                            axiosMode={axiosMode}
                            propsForm={propsForm ? propsForm : form}
                            onFormFinish={onFormFinish}
                            form_data={modal_form_data}
                        />
                    </Col>
                </Row>
            </Modal>
        </>

    )
}


export default CompetencyModal;
